import { DARK_THEME_ID, LIGHT_THEME_ID } from '../../theme/themeIds';

/**
 * The three choices of the Settings page's theme toggle, in its order: a
 * theme, the other, or none — "Auto".
 */
export type ThemeMode = 'light' | 'dark' | 'auto';

export const THEME_MODES: readonly ThemeMode[] = ['light', 'dark', 'auto'];

export const themeModeLabels: Record<ThemeMode, string> = {
  light: 'Clair',
  dark: 'Sombre',
  auto: 'Auto',
};

export function isThemeMode(value: unknown): value is ThemeMode {
  return THEME_MODES.some(mode => mode === value);
}

/**
 * The mode a theme id stands for. `undefined` is "Auto", as on the Settings
 * page. So is an id no installed theme carries — one left in localStorage by
 * an earlier version of the app: AppThemeProvider ignores it and picks the
 * theme from `prefers-color-scheme`, exactly as it does for `undefined`.
 */
export function themeModeOf(activeThemeId: string | undefined): ThemeMode {
  if (activeThemeId === LIGHT_THEME_ID) {
    return 'light';
  }
  if (activeThemeId === DARK_THEME_ID) {
    return 'dark';
  }
  return 'auto';
}

const themeIds: Record<ThemeMode, string | undefined> = {
  light: LIGHT_THEME_ID,
  dark: DARK_THEME_ID,
  auto: undefined,
};

/** The id to hand to `setActiveThemeId`: none for "Auto". */
export function themeIdOf(mode: ThemeMode): string | undefined {
  return themeIds[mode];
}
